import { Box, Skeleton, Text, VStack } from '@chakra-ui/react';

interface InventoryTotalValueCardProps {
    value?: number;
    isLoading?: boolean;
}

const formatCurrency = (v: number) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(v);

/**
 * Live stock-$ KPI for the Inventory list toolbar (left of Add).
 * Shell matches EditInventoryItemDrawer MetricCard; value on top, label below.
 */
export function InventoryTotalValueCard({
    value,
    isLoading = false,
}: InventoryTotalValueCardProps) {
    return (
        <Box
            px={3}
            py={2}
            borderRadius="lg"
            borderWidth="1px"
            borderColor="border.subtle"
            bg="white"
            minW="108px"
            flexShrink={0}
        >
            <VStack spacing={0} align="flex-start">
                <Skeleton isLoaded={!isLoading} h="22px" minW="64px" borderRadius="sm">
                    <Text fontSize="lg" fontWeight="bold" color="fg.default" lineHeight="short">
                        {value !== undefined ? formatCurrency(value) : '—'}
                    </Text>
                </Skeleton>
                <Text
                    fontSize="8px"
                    fontWeight="bold"
                    color="fg.muted"
                    letterSpacing="wide"
                    textTransform="uppercase"
                    mt={0.5}
                >
                    In-Stock Value
                </Text>
            </VStack>
        </Box>
    );
}
